module.exports = __webpack_public_path__ + "img/step4a-en.6475e1b7.webp";